import { AlbumTitle } from "../../constants";
import img1 from "../../img/portfolio/pic1.jpg";
import img2 from "../../img/portfolio/pic2.jpg";
import img3 from "../../img/portfolio/pic3.jpg";
import img4 from "../../img/portfolio/pic4.jpg";
import img5 from "../../img/portfolio/pic5.jpg";
import img6 from "../../img/portfolio/pic6.jpg";
import img7 from "../../img/portfolio/pic7.jpg";
import img8 from "../../img/portfolio/pic8.jpg";
import img9 from "../../img/portfolio/pic9.jpg";

const Album: React.FC<{}> = () => {
  return (
    <div>
      <section id="portfolio" className="section-bg">
        <div className="container">
          <header className="section-header">
            <h3 className="section-title">{AlbumTitle}</h3>
          </header>

          <div className="row portfolio-container" style={{ opacity: 1 }}>
            <div className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp">
              <div className="portfolio-wrap">
                <figure>
                  <img src={img1} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img2} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img3} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp">
              <div className="portfolio-wrap">
                <figure>
                  <img src={img4} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img5} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-app wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img6} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp">
              <div className="portfolio-wrap">
                <figure>
                  <img src={img9} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-card wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img7} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-web wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="portfolio-wrap">
                <figure>
                  <img src={img8} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Album;
